module.exports = __webpack_public_path__ + "static/media/icon-expert-label.png";